<template>
  <div>
    <vs-sidebar click-not-close parent="#tranksaksi-app" :hidden-background="true" class="full-vs-sidebar tranksaksi-view-sidebar items-no-padding" v-model="isGudangActive" position-right>
      <div class="px-0 sm:pb-6 h-full tranksaksi-area-loading">
        <div class="flex flex-wrap items-center justify-between md:px-8 px-6 py-5 d-theme-dark-bg tranksaksi-header bg-primary">
          <h5 class="text-white">Tambah Gudang</h5>
          <feather-icon :icon="$vs.rtl ? 'XIcon' : 'XIcon'" @click="gudangAddClose" class="cursor-pointer mr-4" svg-classes="text-white w-6 h-6"></feather-icon>
        </div>

        <component :is="scrollbarTag" class="tranksaksi-scroll-area md:p-8 p-6 mt-base" :settings="settings" :key="$vs.rtl">
          <div class="vx-col w-full sm:w-3/4 items-center sm:flex-row flex-col mx-auto">
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-input label="Gudang" v-model="dataGudang" class="mt-5 w-full" name="item-gudang" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('item-gudang')">{{ errors.first('item-gudang') }}</span>
              </div>
            </div>
            <vs-divider class="mt-base">Informasi Umum</vs-divider>
            <div class="vx-row mb-6">
              <div class="vx-col w-1/2">
                <vs-input type="email" label="Email" v-model="dataEmail" class="mt-2 w-full" name="item-email" v-validate="'required|email'"/>
              </div>
              <div class="vx-col w-1/2">
                <vs-input label="Telepon" v-model="dataTelepon" class="mt-2 w-full" name="item-telepon" v-validate="'required|numeric'"/>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-textarea v-model="dataAlamat" label="Alamat" class="mt-1 w-full"/>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-1/2">
                <vs-button type="border" color="danger" @click="gudangAddClose">Cancel</vs-button>
              </div>
              <div class="vx-col w-1/2 flex justify-end">
                <vs-button :disabled="!isFormValid" @click="submitData" color="primary">Submit</vs-button>
              </div>
            </div>
          </div>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
export default{
  props: {
    isGudangActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },

      dataId: null,
      dataGudang: null,
      dataGroup: 0,
      dataParent: 0,
      dataEmail: null,
      dataTelepon: null,
      dataAlamat: null
    }
  },
  watch: {
    isGudangActive (value) {
      if (!value) { return } 
    }
  },
  computed: {
    scrollbarTag () { 
      return this.$store.getters.scrollbarTag
    },
    windowWidth ()  { 
      return this.$store.state.windowWidth                 
    },
    isFormValid () {
      return !this.errors.any() && this.dataGudang && this.dataTelepon && this.dataAlamat
    },
    ...mapGetters({
      user : 'auth/user',
    })
  },
  methods: {
    initValues() {
      //if (this.gudangData.id) return
      this.dataId = null
      this.dataGudang = null
      this.dataGroup = 0
      this.dataParent = 0
      this.dataEmail = null
      this.dataTelepon = null
      this.dataAlamat = null
    },
    gudangAddClose() {
      this.$emit('closeGudang')
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name: this.dataGudang,
            term_group: this.dataGroup,
            parent: this.dataParent,

            meta : {
              email: this.dataEmail,
              telepon: this.dataTelepon,
              alamat: this.dataAlamat
            },
            taxonomy: 'gudang'
          }

          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('gudang/updateGudang', obj)
          } else {
            delete obj.id
            this.$store.dispatch('gudang/addGudang', obj)
          }
          this.$emit('closeGudang')
          this.initValues()
        }
      })
    }
  }
}

</script>